import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui 约定的类名合并工具。 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/** 格式化时间戳为本地 `YYYY-MM-DD HH:mm:ss`。 */
export function formatTime(ts?: number | null): string {
  if (!ts) return '—'
  const d = new Date(ts)
  const p = (n: number, w = 2) => String(n).padStart(w, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

/** 相对时间（用于「最后在线」等展示）。 */
export function relativeTime(ts?: number | null): string {
  if (!ts) return '从未'
  const diff = Date.now() - ts
  const s = Math.floor(diff / 1000)
  if (s < 60) return `${s} 秒前`
  const m = Math.floor(s / 60)
  if (m < 60) return `${m} 分钟前`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h} 小时前`
  const d = Math.floor(h / 24)
  return `${d} 天前`
}

/** 把 7 位仪器激活码按 3-4 分组展示，降低人工转录错误。 */
export function formatActivationCode(code: string): string {
  if (code.length !== 7) return code
  return `${code.slice(0, 3)} ${code.slice(3)}`
}

/** 把 6 位维护动态密码按 3-3 分组。 */
export function formatDynamicCode(code: string): string {
  if (code.length !== 6) return code
  return `${code.slice(0, 3)} ${code.slice(3)}`
}
